const getDemarcacioByCodiMunicipi = (code) => {
    const provincies = {
        '01': 'Àlaba',
        '02': 'Albacete',
        '03': 'Alacant',
        '04': 'Almeria',
        '05': 'Àvila',
        '06': 'Badajoz',
        '07': 'Illes Balears',
        '08': 'Barcelona',
        '09': 'Burgos',
        '10': 'Càceres',
        '11': 'Cadis',
        '12': 'Castelló',
        '13': 'Ciudad Real',
        '14': 'Còrdova',
        '15': 'La Corunya',
        '16': 'Conca',
        '17': 'Girona',
        '18': 'Granada',
        '19': 'Guadalajara',
        '20': 'Guipúscoa',
        '21': 'Huelva',
        '22': 'Osca',
        '23': 'Jaén',
        '24': 'Lleó',
        '25': 'Lleida',
        '26': 'La Rioja',
        '27': 'Lugo',
        '28': 'Madrid',
        '29': 'Màlaga',
        '30': 'Múrcia',
        '31': 'Navarra',
        '32': 'Ourense',
        '33': 'Astúries',
        '34': 'Palència',
        '35': 'Las Palmas',
        '36': 'Pontevedra',
        '37': 'Salamanca',
        '38': 'Santa Cruz de Tenerife',
        '39': 'Cantàbria',
        '40': 'Segòvia',
        '41': 'Sevilla',
        '42': 'Sòria',
        '43': 'Tarragona',
        '44': 'Terol',
        '45': 'Toledo',
        '46': 'València',
        '47': 'Valladolid',
        '48': 'Biscaia',
        '49': 'Zamora',
        '50': 'Saragossa',
        '51': 'Ceuta',
        '52': 'Melilla'
    };

    const codiProvincia = code.toString().substring(2, 4);
    return provincies[codiProvincia];
};

const isCodiAutonomia = (code) => {
    const str = String(code);
    return /^\d{11}$/.test(str) && str.slice(2) === '000000000' && str.slice(0, 2) !== '00';
};

const isCodiDemarcacio = (code) => {
    const str = String(code);
    return /^\d{11}$/.test(str) && str.slice(4) === '0000000' && str.slice(2, 4) !== '00';
};

const isCodiComarca = (code) => {
    const str = String(code);
    return /^\d{11}$/.test(str) && str.slice(6) === '00000' && str.slice(4, 6) !== '00';
};

const isCodiMunicipi = (code) => {
    const str = String(code);
    return /^\d{11}$/.test(str) && str.endsWith('00') && str.slice(6, 11) !== '00000';
};

const isMunicipiFromDemarcacio = (codeMunicipi, codeDemarcacio) => {
    codeDemarcacio = String(codeDemarcacio);
    const idDemarcacio = codeDemarcacio.length === 11 ? codeDemarcacio.slice(2, 4) : codeDemarcacio;
    return String(codeMunicipi).slice(2, 4) === idDemarcacio;
};

const isMunicipiFromComarca = (codeMunicipi, codeComarca) => {
    codeComarca = String(codeComarca);
    const idComarca = codeComarca.length === 11 ? codeComarca.slice(4, 6) : codeComarca;
    return String(codeMunicipi).slice(4, 6) === idComarca;
};

const isMunicipiFromAutonomia = (codeMunicipi, codeAutonomia) => {
    codeAutonomia = String(codeAutonomia);
    const idAutonomia = codeAutonomia.length === 11 ? codeAutonomia.slice(0, 2) : codeAutonomia;
    return String(codeMunicipi).slice(0, 2) === idAutonomia;
};

const getRoutePathByCode = (code) => {
    if (isCodiAutonomia(code)) {
        return 'web_3catinfo_eleccions_autonomia';
    } else if (isCodiDemarcacio(code)) {
        return 'web_3catinfo_eleccions_provincia';
    } else if (isCodiComarca(code)) {
        return 'web_3catinfo_eleccions_comarca';
    } else if (isCodiMunicipi(code)) {
        return 'web_3catinfo_eleccions_municipi';
    } else {
        return 'web_3catinfo_eleccions_home';
    }
};

export {
    getDemarcacioByCodiMunicipi,
    isCodiAutonomia,
    isCodiComarca,
    isCodiDemarcacio,
    isCodiMunicipi,
    isMunicipiFromDemarcacio,
    isMunicipiFromAutonomia,
    isMunicipiFromComarca,
    getRoutePathByCode
};
